import React, { useState, useEffect } from 'react';
import { Button, Card, CardHeader, Form, FormGroup, Input, Modal } from 'reactstrap';
import { putDocumentoCliente } from 'services/DocumentosClienteService';
import { successAlert, warningAlert } from 'pages/components/SweetAlert';

const ModalEditarDocumento = ({ isOpen, toggle, documento, traerDocumentos }) => {
    const [nombre, setNombre] = useState("");
    const [descripcion, setDescripcion] = useState("");
    const [loading, setLoading] = useState(false);
    const [alert, setAlert] = useState("");

    useEffect(() => {
        if (documento) {
            setNombre(documento.nombre || "");
            setDescripcion(documento.descripcion || "");
        }
    }, [documento]);

    const resetForm = () => {
        setAlert("");
    };

    const guardarCambios = async () => {
        if (!nombre) {
            warningAlert(setAlert, 'Campo requerido', 'El nombre del documento es obligatorio.');
            return;
        }

        if (nombre.length > 50) {
            warningAlert(setAlert, 'Nombre demasiado largo', 'El nombre del documento no puede superar los 50 caracteres.');
            return;
        }

        if (descripcion.length > 500) {
            warningAlert(setAlert, 'Descripción demasiado larga', 'La descripción del documento no puede superar los 500 caracteres.');
            return;
        }

        setLoading(true);
        const docActualizado = { ...documento, nombre, descripcion };
        const result = await putDocumentoCliente(docActualizado);

        if (result && result.ok) {
            successAlert(setAlert, 'Documento actualizado', result.mensaje || 'El documento fue actualizado correctamente.');
            traerDocumentos();
            toggle();
        } else {
            warningAlert(setAlert, 'Error', 'No se pudo actualizar el documento.');
        }

        setLoading(false);
    };

    return (
        <>
            {alert}
            <Modal
                className="modal-dialog-centered"
                size="sm"
                isOpen={isOpen}
                toggle={() => {
                    resetForm();
                    toggle();
                }}
            >
                <div className="modal-body p-0">
                    <Card className="bg-secondary shadow border-0">
                        <CardHeader className="bg-transparent pb-5">
                            <div className="text-center mb-3">
                                <b>Editar Documento</b>
                                <button
                                    aria-label="Close"
                                    className="close"
                                    data-dismiss="modal"
                                    type="button"
                                    onClick={() => {
                                        resetForm();
                                        toggle();
                                    }}
                                >
                                    <span aria-hidden={true}>×</span>
                                </button>
                            </div>
                            <Form role="form">
                                <FormGroup className="mb-3">
                                    <Input
                                        placeholder="Nombre del documento..."
                                        type="text"
                                        value={nombre}
                                        onChange={(e) => setNombre(e.target.value)}
                                        maxLength={50}
                                    />
                                </FormGroup>
                                <FormGroup className="mb-3">
                                    <textarea
                                        placeholder="Descripción del documento..."
                                        value={descripcion}
                                        onChange={(e) => setDescripcion(e.target.value)}
                                        rows={3}
                                        className="form-control"
                                        maxLength={500}
                                    />
                                </FormGroup>
                                <div className="text-center">
                                    <Button
                                        className="my-4"
                                        color="primary"
                                        type="button"
                                        onClick={guardarCambios}
                                        disabled={loading}
                                    >
                                        {loading ? 'Guardando...' : 'Guardar cambios'}
                                    </Button>
                                    <Button
                                        color="secondary"
                                        data-dismiss="modal"
                                        type="button"
                                        onClick={() => {
                                            resetForm();
                                            toggle();
                                        }}
                                    >
                                        Cerrar
                                    </Button>
                                </div>
                            </Form>
                        </CardHeader>
                    </Card>
                </div>
            </Modal>
        </>
    );
};

export default ModalEditarDocumento;
